import React, { createContext } from "react";
import { UserProvider } from "./User.context";
import { ModalProvider } from "./Modal.provider";

export default function AppProviders({ children }) {
  return (
    <UserProvider>
      <ModalProvider>{children}</ModalProvider>
    </UserProvider>
  );
}
